import React, { useState } from 'react'
import { Box, Typography } from '@mui/material'
import ActivityBlockCard from '../components/ActivityBlockCard'
import PeriodNavigator from '../components/PeriodNavigator'
import { todayIso } from '../format'
import { advancedColors } from '../theme'
import { usePatientActivity } from '../api/patientActivity'
import { dayFor, dayLabel } from './weekDates'

const DailyActivityBoard = () => {
  const [dayOffset, setDayOffset] = useState(0)
  const day = dayFor(todayIso(), dayOffset)
  const blocks = usePatientActivity().get(day.iso) ?? []

  return (
    <Box>
      <PeriodNavigator
        label={dayLabel(day)}
        unit="day"
        onStep={(delta) => setDayOffset((value) => value + delta)}
        labelWidth={180}
      />

      {blocks.length > 0 ? (
        blocks.map((block) => <ActivityBlockCard key={block.id} block={block} size="comfortable" />)
      ) : (
        <Typography variant="subtitle1" sx={{ color: advancedColors.inkFaint }}>
          No activity
        </Typography>
      )}
    </Box>
  )
}

export default DailyActivityBoard
